/* 中文词典：common 命名空间（跨屏复用的固定文案）。见 src/i18n/README.md。 */

import type { TextSpec } from '../text';

const common = {
  // ---- 通用返回 ----
  'common.back': [ '返回  (ESC)' ],
  'common.backPlain': [ '返回' ],
  // ---- 页面 / 按钮标题 ----
  'common.settings': [ '设置' ],
  'common.credit': [ '鸣谢' ],
  'common.changelog': [ '更新日志' ],
  'common.close': [ '关闭' ],
  'common.netplay': [ '联机游玩' ],
  'common.room': [ '房间' ],
  'common.createRoom': [ '创建房间' ],
  'common.identity': [ '身份' ],
  'common.nickname': [ '昵称' ],
  'common.host': [ '主机' ],
  'common.endTurn': [ '结束回合' ],
  'common.gameOver': [ '对局结束' ],
  'common.rulesAndDeck': [ '游戏规则与牌堆' ],
  'common.resetDefaults': [ '恢复默认' ],
  'common.unknownReason': [ '未知原因' ],
  'common.problemSeparator': [ '；' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
common satisfies Record<string, TextSpec>;
export default common;
